// ══════════════════════════════════════════════════════════════════
//  ED CRM - Helper de copiar para clipboard com feedback de toast
// ══════════════════════════════════════════════════════════════════
//  Copia o texto bruto (sem formatação extra) e dispara toast de
//  sucesso/erro. Fallback para browsers antigos via document.execCommand.
//
//  Uso:
//    onClick={(e) => { e.stopPropagation(); copyToClipboard(lead.telefone, 'Telefone'); }}
// ══════════════════════════════════════════════════════════════════

import { toast, toastError } from './toast';

export const copyToClipboard = async (text: unknown, label = 'Texto'): Promise<boolean> => {
  if (!text) return false;
  const value = String(text);
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
    } else {
      // Fallback (browsers antigos / contexto sem permissão)
      const ta = document.createElement('textarea');
      ta.value = value;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    toast.success(`${label} copiado`);
    return true;
  } catch (err) {
    toastError('Falha ao copiar', err);
    return false;
  }
};

// Atalho específico para telefone — copia só os dígitos (sem +55, parênteses
// ou hífens), formato pronto pra colar em campos de discagem.
export const copyPhone = (phone: unknown): boolean | Promise<boolean> => {
  if (!phone) return false;
  const digits = String(phone).replace(/\D/g, '');
  return copyToClipboard(digits, 'Telefone');
};
